import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../hooks/useLanguage';

const LegalLangToggle = () => {
  const { t } = useTranslation('footer');
  const { currentLanguage, changeLanguage } = useLanguage();

  return (
    <div className="legal-lang" role="group" aria-label={t('language')}>
      {['fr', 'en'].map((code) => (
        <button
          key={code}
          type="button"
          className={currentLanguage === code ? 'is-active' : ''}
          onClick={() => changeLanguage(code)}
          aria-pressed={currentLanguage === code}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default LegalLangToggle;
